import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, EmailTemplateInfo } from 't4core';


@Component({
  selector: 'serviceMessageDialog',
  templateUrl: 'serviceMessageDialog.html',
})
export class ServiceMessageDialogDialog extends DialogBase implements OnInit {

  public dialogTitle: string = "Send a Message";
  public dialogInfoTitle: string = "";
  public dialogDescription: string = "";
  public templateKey: string = "";
  public templateType: number;

  public templates: EmailTemplateInfo[] = [];

  public message: string = "";
  public templateKeys: string[] = [];
  public templateKeyMap: { [display: string]: string } = {};
  public selectedTemplateKey: string | undefined;
  public selectedFriendlyName: string | undefined;
  public filteredTemplates: EmailTemplateInfo[] = [];
  public selectedTemplate: EmailTemplateInfo | undefined;

  constructor(
    public dialogRef: MatDialogRef<ServiceMessageDialogDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ServiceMessageDialogDialog");

    console.log(this.data);

    this.dialogTitle = this.data.dialogTitle ?? "Send a Message";
    this.dialogDescription = this.data.dialogDescription ?? "";
    this.templateKey = this.data.templateKey ?? "";
    this.templateType = this.data.templateType ?? 0;
    this.dialogInfoTitle = this.data.dialogInfoTitle ?? "";

  }


  public async ngOnInit() {

    if (this.templateKey) {
      this.templates = await this.Api.get<EmailTemplateInfo[]>("Settings/GetContentTemplatesByKey", { type: this.templateType, key: this.templateKey });

      const fullKeys = Array.from(new Set(this.templates.map(t => t.Key)));
      // remove the prefix (templateKey) from display values
      this.templateKeyMap = {};
      this.templateKeys = fullKeys.map(k => {
        let display = (this.templateKey && k.startsWith(this.templateKey)) ? k.substring(this.templateKey.length) : k;
        // remove any leading dot if the provided templateKey didn't include it (Failsafe)
        display = display.replace(/^\./, '');
        this.templateKeyMap[display] = k;
        return display;
      });
      if (this.templateKeys.length) {
        this.selectedTemplateKey = this.templateKeys[0];
        this.onTemplateKeyChange(this.selectedTemplateKey);
      } else {
        this.filteredTemplates = this.templates;
        if (this.filteredTemplates.length) {
          this.selectedTemplate = this.filteredTemplates[0];
          this.selectedFriendlyName = this.selectedTemplate.FriendlyName;
        }
      }
    }

  }

  public onTemplateKeyChange(key: string | undefined) {
    if (!key) {
      this.filteredTemplates = [];
      this.selectedTemplate = undefined;
      this.selectedFriendlyName = undefined;
      return;
    }
    // map the display key back to full key
    const fullKey = this.templateKeyMap[key] ?? key;
    this.filteredTemplates = this.templates.filter(t => t.Key === fullKey);
    if (this.filteredTemplates.length) {
      this.selectedTemplate = this.filteredTemplates[0];
      this.selectedFriendlyName = this.selectedTemplate.FriendlyName;
    } else {
      this.selectedTemplate = undefined;
      this.selectedFriendlyName = undefined;
    }
  }

  public onFriendlyNameChange(name: string | undefined) {
    if (!name) return;
    this.selectedTemplate = this.filteredTemplates.find(t => t.FriendlyName === name);
  }

  public insertTemplateContent() {
    if (this.selectedTemplate && this.selectedTemplate.Content) {
      this.message = this.selectedTemplate.Content;
    }
  }

  public closeDialog() {
    this.dialogRef.close(this.message);
  }

}
